// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2xbNo","noInteraction":"EventWrapper_noInteraction__g3Ur5","pointerPassthrough":"EventWrapper_pointerPassthrough__32cjw"};